import { useEffect, useState } from 'react';
import { Grid, Pagination } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useGetOrdersWithParamsQuery } from '../../api/ordersApi';
import { orderSearchActions } from '../../store/search/order-search-slice';
import OrdersListingTable from '../../components/tables/OrdersListingTable';
import OrderSummaryCard from '../../components/cards/order/OrderSummaryCard';
import Colors from '../../constants/Colors';

import Spinner from '../../components/layout/Spinner';
import SearchFeedback from '../../components/feedback/SearchFeedback';
import OrdersQueryResultsTotalizersCard from '../../components/cards/queries/OrdersQueryResultsTotalizersCard';
import {
  loadOrderSearchParams,
  saveOrderSearchParams,
} from '../../util/orderSearchStorage';

const ListSales = (): JSX.Element => {
  const [isSearchHydrated, setIsSearchHydrated] = useState(false);
  const visualization = useAppSelector(
    (state) => state.visualization.visualization
  );
  const searchParams = useAppSelector((state) => state.orderSearch);
  const userId = useAppSelector((state) => state.auth.userId);
  const { data, isError, isFetching, isLoading } =
    useGetOrdersWithParamsQuery(
      { ...searchParams, vendedorId: userId || '' },
      { skip: !isSearchHydrated },
    );

  const dispatch = useAppDispatch();

  useEffect(() => {
    const savedParams = loadOrderSearchParams();

    if (savedParams) {
      dispatch(orderSearchActions.setSearchState(savedParams));
    }

    setIsSearchHydrated(true);
  }, [dispatch]);

  useEffect(() => {
    if (isSearchHydrated) {
      saveOrderSearchParams(searchParams);
    }
  }, [isSearchHydrated, searchParams]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    dispatch(orderSearchActions.changePage(value));
  };

  if (!isSearchHydrated || isFetching || isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <h2>Erro ao carrgar dados dos pedidos</h2>;
  }

  if (data && data.pedidos.length === 0) {
    return <SearchFeedback />;
  }

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <OrdersQueryResultsTotalizersCard
          orders={data ? data.pedidos : []}
          totalizador={data?.totalizador}
        />
      </Grid>
      {visualization === 'CARD' && (
        <Grid container spacing={2}>
          {data?.pedidos.map((order) => {
            return <OrderSummaryCard order={order} />;
          })}
        </Grid>
      )}
      {visualization === 'TABLE' && (
        <OrdersListingTable orders={data ? data.pedidos : []} />
      )}
      {data && data?.totalPages > 1 && (
        <Pagination
          size='small'
          showFirstButton
          showLastButton
          page={searchParams.page}
          count={data?.totalPages}
          sx={{
            '& .MuiPaginationItem-root': {
              '&.Mui-selected': {
                background: Colors.mainLayoutAtiveBackground,
                color: 'black',
              },
            },
            width: '100%',
          }}
          onChange={handleChange}
        />
      )}
    </>
  );
};

export default ListSales;
